import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { LocaleLink } from '@common/components';
import styles from './Logo.module.scss';
import { getLanguagePrefix } from '@helpers';

const iconThemeLight = require('./assets/images/icons/logo.svg');

export const LOGO_THEME = {
  dark: 'Logo/Theme/Dark',
  light: 'Logo/Theme/Light',
};

export const Logo = ({ alt, theme, className, imgClassName }) => {
  const { prefixLanguage: language } = useSelector(({ appState }) => appState);
  return (
    <LocaleLink
      to={`${window.location.origin}${getLanguagePrefix(language)}/`}
      className={classNames(styles.link, className)}
    >
      <img
        src={iconThemeLight.default}
        className={[
          styles.icon,
          imgClassName,
          theme === LOGO_THEME.dark ? styles.iconThemeDark : '',
        ].join(' ')}
        alt={alt}
      />
    </LocaleLink>
  );
};

Logo.propTypes = {
  alt: PropTypes.string.isRequired,
  theme: PropTypes.string,
  className: PropTypes.string,
  imgClassName: PropTypes.string,
};

Logo.defaultProps = {
  theme: LOGO_THEME.light,
  className: undefined,
  imgClassName: undefined,
};
